module.exports = __webpack_public_path__ + "img/page5.e30bb5ae.png";